
    require(
      "!../../node_modules/gatsby/dist/loaders/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { 
     return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./graphql-java-4-connectors.json") })
        }
      }, "path---graphql-java-4-connectors");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby/dist/loaders/gatsby-module-loader?name=path---graphql-java-4-connectors!./.cache/json/graphql-java-4-connectors.json
// module id = ./node_modules/gatsby/dist/loaders/gatsby-module-loader/index.js?name=path---graphql-java-4-connectors!./.cache/json/graphql-java-4-connectors.json
// module chunks = 154